import * as React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import { FirmProduct } from '../types';

type ProductCardProps = {
    product: FirmProduct;
    chosen: boolean;
    choice: 'one' | 'many';
    locked: boolean;
    onChoose: () => void;
};

export function ProductCard({ product, chosen, choice, locked, onChoose }: ProductCardProps) {
    let nameId = `create-order-product-${product.id}-name`;
    let descriptionId = `create-order-product-${product.id}-description`;
    let control = {
        checked: chosen,
        disabled: locked,
        onChange: onChoose,
        color: 'default' as const,
        sx: { color: 'inherit', '&.Mui-checked': { color: 'inherit' } },
        inputProps: { 'aria-labelledby': nameId, 'aria-describedby': descriptionId }
    };

    return (
        <Paper
            component="label"
            variant="outlined"
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 8px 8px 16px',
                cursor: locked ? 'default' : 'pointer',
                backgroundColor: chosen ? 'secondary.dark' : 'background.paper',
                color: chosen ? 'secondary.contrastText' : 'text.primary'
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Typography id={nameId} sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                    {product.name}
                </Typography>
                <Typography id={descriptionId} sx={{ fontSize: '12px' }}>
                    {product.extraText}
                </Typography>
            </Box>
            {product.priceBrokerFirm && (
                <Chip
                    size="small"
                    variant="outlined"
                    label={`${product.priceBrokerFirm.value}${product.currencySign}`}
                    sx={{ color: 'inherit', borderColor: 'currentColor', fontSize: '12px' }}
                />
            )}
            {choice === 'one' ? <Radio {...control} /> : <Checkbox {...control} />}
        </Paper>
    );
}
